import { IconProps } from '@drift-labs/icons';
import { cj } from 'src/utils/classNames';

export default function Phantom({
	className,
	color,
	size = 16,
	...props
}: IconProps) {
	return (
		<span className={cj('inline-flex', className)} {...props}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				fill="none"
				viewBox="0 0 24 20"
			>
				<path
					fill={color ?? 'currentColor'}
					fillRule="evenodd"
					d="M9.578 15.228C8.204 17.335 5.903 20 2.84 20 1.392 20 0 19.404 0 16.813 0 10.214 9.002 0 17.355 0 22.107 0 24 3.3 24 7.046c0 4.809-3.118 10.307-6.218 10.307-.984 0-1.466-.54-1.466-1.398q0-.335.11-.727c-1.057 1.808-3.099 3.486-5.01 3.486-1.393 0-2.098-.876-2.098-2.106 0-.448.093-.914.26-1.38m11.286-8.313c0 1.092-.644 1.638-1.364 1.638-.73 0-1.364-.546-1.364-1.638s.633-1.637 1.364-1.637c.72 0 1.364.546 1.364 1.637m-4.091 0c0 1.092-.644 1.638-1.364 1.638-.73 0-1.364-.546-1.364-1.638s.633-1.637 1.364-1.637c.72 0 1.364.546 1.364 1.637"
					clipRule="evenodd"
				/>
			</svg>
		</span>
	);
}
